import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import FormLine from 'src/components/ui/FormLine/FormLine';
import FieldRepeater from 'src/components/ui/FieldRepeater';

const DefaultForm = (props) => {
	const { groups = [] } = props;
	return (
		<Box>
			<Grid container spacing={3}>
				{groups.map((group) => {
					const { lines = [] } = group;
					return (
						<Grid key={group.id} item xs={12}>
							{lines.length > 0 && (
								<Grid container spacing={2} alignItems="center">
									{lines.map((line) => {
										let RepeaterComponent = FieldRepeater;
										const { Component, ...restRepeater } = line.repeater || {};

										if (Component) {
											RepeaterComponent = Component;
										}

										return (
											<Grid key={line.id} item xs={12} {...line.grid}>
												{line.field && <FormLine {...line.field} />}
												{line.repeater && (
													<RepeaterComponent {...restRepeater} />
												)}
											</Grid>
										);
									})}
								</Grid>
							)}
						</Grid>
					);
				})}
			</Grid>
		</Box>
	);
};

DefaultForm.propTypes = {
	groups: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			lines: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
					field: PropTypes.shape(FormLine.propTypes),
					repeater: PropTypes.shape(FieldRepeater.propTypes),
					grid: PropTypes.shape(Grid.propTypes),
				}),
			),
		}),
	),
};

export default DefaultForm;
